module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("You logged "), _c('span', [_vm._v(_vm._s(_vm.fourteentime))]), _vm._v(" in the last "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/seven"
    }
  }, [_vm._v("7 days")]), _vm._v(" "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/fourteen"
    }
  }, [_vm._v("14 days")]), _vm._v(" "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/thirty"
    }
  }, [_vm._v("30 days")])], 1), _vm._v(" "), _c('reports-charts', {
    attrs: {
      "chart-data": _vm.datasetsfull,
      "height": 300,
      "options": {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf269e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Fourteen.vue
// module id = 383
// module chunks = 1